import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { NextIcon } from "../../../components/common/IconComponents";

const PasswordTab = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(null);

  const handleNextClick = (page) => {
    const routes = {
      changePassword: '/changePassword',
      forgotpassword: '/forgotpassword',
    };
    navigate(routes[page]);
  };

  const pages = [
    {
      id: 'changePassword',
      label: 'Change Password',
      description: 'Change your Password at any time',
    },
    {
      id: 'forgotpassword',
      label: 'Forgot Password',
      description: 'Retrieve your Password at any time',
    },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div className="">
      <div className="mx-3">
        <nav className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white`}>
          <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
        </nav>

        <div className="mt-4 md:mt-24 mb-4">
          {pages.map((page) => (
            <div
              key={page.id}
              className={`flex items-center mb-4 py-2 px-2 md:px-4 cursor-pointer ${activeTab === page.id ? 'bg-th-bg' : ''
                }`}
              onClick={() => handleTabClick(page.id)}
            >
              <div className="flex-grow">
                <h2 className="text-sm md:text-base font-normal text-activesettings-text">{page.label}</h2>
                <p className="text-xs md:text-sm text-teams-body-text">{page.description}</p>
              </div>
              <div>
                <button
                  className=""
                  onClick={() => handleNextClick(page.id)}
                >
                  <NextIcon />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PasswordTab;


// import React from "react";
// import { useNavigate } from 'react-router-dom';
// import PasswordTabNavigation from "./PasswordTabNavigation";

// const PasswordTab = () => {
//   const navigate = useNavigate();

//   const handleTabClick = (tabId) => {
//     if (tabId === 'Change Password') {
//       navigate('/changePassword');
//     } else if (tabId === 'Forgot Password') {
//       navigate('/forgotpassword');
//     }
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white`}>
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleTabClick} />
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;


// recent and okay as well
// import PasswordTabNavigation from './PasswordTabNavigation';
// import { useNavigate } from 'react-router-dom';

// const PasswordTab = () => {
//   const navigate = useNavigate();

//   const handleNextButtonClick = () => {
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       path: '/changePasswordNavigation',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       path: '/forgotpassword',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   const navigateToPage = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav
//           className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white`}
//         >
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleNextButtonClick} navigateToPage={navigateToPage} />
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;







// fall back - recent
// import PasswordTabNavigation from './PasswordTabNavigation';
// import { useNavigate } from 'react-router-dom';

// const PasswordTab = () => {
//   const navigate = useNavigate();

//   const handleNextButtonClick = () => {
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       path: '/changepasswordnavigation',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       path: '/forgotpassword',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   const navigateToPage = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav
//           className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white`}
//         >
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleNextButtonClick} navigateToPage={navigateToPage} />
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;









// import PasswordTabNavigation from './PasswordTabNavigation';
// import { useNavigate } from 'react-router-dom';

// const PasswordTab = () => {
//   const navigate = useNavigate();

//   const handleNextButtonClick = () => {
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       path: '/changePasswordNavigation',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       path: '/forgotpassword',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   const navigateToPage = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav
//           className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white`}
//         >
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleNextButtonClick} navigateToPage={navigateToPage} />
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;













// fallback
// import React, { useState } from 'react';
// import PasswordTabNavigation from './PasswordTabNavigation';
// import ChangePasswordTab from './ChangePassword';
// import { useNavigate } from 'react-router-dom';

// const PasswordTab = () => {
//   const [showChangePassword, setShowChangePassword] = useState(false);
//   const navigate = useNavigate();

//   const handleNextButtonClick = () => {
//     setShowChangePassword(true);
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       path: '/changepassword',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       path: '/forgotpassword',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   const navigateToPage = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav
//           className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white ${showChangePassword ? 'hidden' : ''}`}
//         >
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleNextButtonClick} navigateToPage={navigateToPage} />
//         {showChangePassword && <ChangePasswordTab />}
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;










// import React, { useState } from 'react';
// import PasswordTabNavigation from './PasswordTabNavigation';
// import ChangePasswordTab from './ChangePassword';

// const PasswordTab = () => {
//   const [showChangePassword, setShowChangePassword] = useState(false);

//   const handleNextButtonClick = () => {
//     setShowChangePassword(true);
//   };

//   const tabs = [
//     {
//       id: 'Change Password',
//       label: 'Change Password',
//       path: '/changepassword',
//       extraText: 'Change your Password at any time',
//     },
//     {
//       id: 'Forgot Password',
//       label: 'Forgot Password',
//       path: '/forgotpassword',
//       extraText: 'Retrieve your Password at any time',
//     },
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav
//           className={`md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white ${showChangePassword ? 'hidden' : ''
//             }`}
//         >
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} onTabClick={handleNextButtonClick} />
//         {showChangePassword && <ChangePasswordTab />}
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;







// fall back without change password 
// import PasswordTabNavigation from './PasswordTabNavigation';

// const PasswordTab = () => {
//   const tabs = [
//     {
//       id: "Change Password",
//       label: "Change Password",
//       path: "/Changepassword", 
//       extraText: "Change your Password at any time"
//     },
//     {
//       id: "Forgot Password",
//       label: "Forgot Password",
//       path: "/forgotpassword", 
//       extraText: "Retrieve your Password at any time"
//     },
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <nav className="md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//           <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Password</h1>
//         </nav>

//         <PasswordTabNavigation tabs={tabs} />
//       </div>
//     </div>
//   )
// }

// export default PasswordTab;






// import ForgotPassword from '../../../components/signUpForm/ForgotPassword';
// import ChangePasswordTab from './ChangePasswordTab';
// import PasswordTabNavigation from './PasswordTabNavigation';
// import { Link } from 'react-router-dom';

// const PasswordTab = () => {
//   const tabs = [
//     {
//       id: "Change Password",
//       label: "Change Password",
//       content: <ChangePasswordTab />,
//       extraText: "Change your Password at any time"
//     },
//     {
//       id: "Forgot Password",
//       label: "Forgot Password",
//       content: <ForgotPassword />,
//       extraText: "Retrieve your Password at any time"
//     },
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <h1 className="mt-4 text-[28px] font-medium">Password</h1>
//         <PasswordTabNavigation tabs={tabs} />
//       </div>
//     </div>
//   )
// }

// export default PasswordTab;







// FALL BACK
// import ForgotPassword from '../../../components/signUpForm/ForgotPassword';
// import ChangePasswordTab from './ChangePasswordTab';
// import PasswordTabNavigation from './PasswordTabNavigation';

// const PasswordTab = () => {
//   const tabs = [
//     {
//       id: "Change Password",
//       label: "Change Password",
//       content: <ChangePasswordTab />,
//        extraText: "Change your Password at any time"
//     },
//     {
//       id: "Forgot Password",
//       label: "Forgot Password",
//       content: <ForgotPassword />,
//       extraText: "Retrieve your Password at any time"
//     },
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <h1 className="mt-4 text-[28px] font-medium">Password</h1>
//         <PasswordTabNavigation tabs={tabs} />
//       </div>
//     </div>
//   )
// }

// export default PasswordTab;







// import React from "react";
// import ForgotPassword from "../../../components/signUpForm/ForgotPassword";
// import ChangePasswordTab from "./ChangePasswordTab";
// import PasswordTabNavigation from "./PasswordTabNavigation";

// const PasswordTab = () => {
//   const tabs = [
//     {
//       id: "Change Password",
//       label: "Change Password",
//       content: <ChangePasswordTab />,
//       link: "/changePasswordPage" // Replace with the URL of the new page
//     },
//     {
//       id: "Forgot Password",
//       label: "Forgot Password",
//       content: <ForgotPassword />,
//       link: "/forgotPassword // Replace with the URL of the new page
//     }
//   ];

//   return (
//     <div className="">
//       <div className="mx-3">
//         <PasswordTabNavigation tabs={tabs} />
//       </div>
//     </div>
//   );
// };

// export default PasswordTab;
